import { all, call, put, fork, takeEvery } from 'redux-saga/effects';
import { sendStat } from '../../hooks/sendStat';
import { callApi } from '../../utils/callApi';
import { TYPE_EVENT_SEND_MESSAGE } from '../../utils/consts';
import { ApiEvents } from '../../utils/SocketEvents';
import {
  GetMessages,
  GetWebinarCertificate,
  LikeMessage,
  MetricsUkd,
  SendMessage,
  ShowEvent,
  SocketActions,
  TypeGetMessagesR,
  TypeGetWebinarCertificateR,
  TypeLikeMessageR,
  TypeMetricsUkdR,
  TypeSendMessageR,
  TypeShowEventsR,
} from './actions';
import ActionTypes, { TShowEvent, TSocketState } from './types';

function* showEvent(action: ReturnType<typeof ShowEvent.request>): Generator {
  const { data, callBack } = action.payload as TypeShowEventsR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.events,
    })) as TShowEvent;
    yield put(ShowEvent.success(resp));
  } catch (e) {
    success = false;
    yield call(ShowEvent.error, e as string);
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* sendMessage(action: ReturnType<typeof SendMessage.request>): Generator {
  const { data, callBack } = action.payload as TypeSendMessageR;

  let success = true;
  try {
    yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.newM,
    });
    sendStat(TYPE_EVENT_SEND_MESSAGE);
  } catch (e) {
    success = false;
    yield put(SocketActions.setSocketError(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* likeMessage(action: ReturnType<typeof LikeMessage.request>): Generator {
  const { data, callBack } = action.payload as TypeLikeMessageR;

  let success = true;
  try {
    yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.likeM,
    });
  } catch (e) {
    success = false;
    yield put(SocketActions.setSocketError(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* metricsUkd(action: ReturnType<typeof MetricsUkd.request>): Generator {
  const { data, callBack } = action.payload as TypeMetricsUkdR;

  let success = true;
  try {
    yield call(callApi, {
      method: 'post',
      data,
      path: '/api/ukd/metrics-ukd',
    });
  } catch (e) {
    success = false;
    yield put(MetricsUkd.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* getWebinarCertificate(action: ReturnType<typeof GetWebinarCertificate.request>): Generator {
  const { data, callBack } = action.payload as TypeGetWebinarCertificateR;

  let success = true;
  try {
    const resp = yield call(callApi, {
      method: 'post',
      data,
      path: '/api/certificates/webinar',
    }) as unknown as Buffer;
    const buffer = Buffer.from(resp as string, 'base64');
    const url = window.URL.createObjectURL(new Blob([buffer], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `certificate_event_${data.event_id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (e) {
    success = false;
    yield put(GetWebinarCertificate.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* getMessages(action: ReturnType<typeof GetMessages.request>): Generator {
  const { data, callBack } = action.payload as TypeGetMessagesR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.getMessages,
    })) as TSocketState['chat'];
    yield put(GetMessages.success(resp));
  } catch (e) {
    success = false;
    yield put(GetMessages.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* watchFetchRequest() {
  yield takeEvery(ActionTypes.SHOW_EVENT_R, showEvent);
  yield takeEvery(ActionTypes.SEND_MESSAGE_R, sendMessage);
  yield takeEvery(ActionTypes.LIKE_MESSAGE_R, likeMessage);
  yield takeEvery(ActionTypes.METRICS_UKD_R, metricsUkd);
  yield takeEvery(ActionTypes.GET_WEBINAR_CERTIFICATE_R, getWebinarCertificate);
  yield takeEvery(ActionTypes.GET_MESSAGES_R, getMessages);
}

export default function* socketsSaga() {
  yield all([fork(watchFetchRequest)]);
}
